import { Anchor, Breadcrumbs, Group, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

export interface Crumb {
  label: string;
  to?: string;
}

export function PageHeader({
  title,
  description,
  actions,
  crumbs,
  badge,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  crumbs?: Crumb[];
  badge?: ReactNode;
}) {
  return (
    <Stack gap={6} mb="md">
      {crumbs && crumbs.length > 0 && (
        <Breadcrumbs separatorMargin={6} fz="sm">
          {crumbs.map((c) =>
            c.to ? (
              <Anchor key={c.label} component={Link} to={c.to} c="dimmed">
                {c.label}
              </Anchor>
            ) : (
              <Text key={c.label} c="dimmed" fz="sm">
                {c.label}
              </Text>
            ),
          )}
        </Breadcrumbs>
      )}
      <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
        <Stack gap={4} style={{ minWidth: 0, flex: '1 1 320px' }}>
          <Group gap="sm" wrap="nowrap">
            <Title order={2} fz={{ base: 22, sm: 26 }} style={{ minWidth: 0 }}>
              {title}
            </Title>
            {badge}
          </Group>
          {description && (
            <Text c="dimmed" fz="sm" maw={720}>
              {description}
            </Text>
          )}
        </Stack>
        {actions && <Group gap="sm">{actions}</Group>}
      </Group>
    </Stack>
  );
}
